export default __webpack_public_path__ + "static/media/pond_2048_1536.a0979c5e.jpg";